import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface VisitNotesSectionProps {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  notes: string;
  onNotesChange: (notes: string) => void;
  notesPinned: boolean;
  onNotesPinnedChange: (pinned: boolean) => void;
}

function PinCheckbox(props: {
  checked: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
      <input
        type="checkbox"
        checked={props.checked}
        disabled={props.disabled}
        onChange={(e) => props.onChange(e.target.checked)}
        className="mt-1 h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500 disabled:opacity-50"
      />
      <span>
        <span className="block text-sm font-semibold text-gray-900">
          Als PoS-Dauerinfo anpinnen
        </span>
        <span className="block text-xs text-gray-500 mt-0.5">
          Pin to this PoS so it stays visible on every future visit
        </span>
      </span>
    </label>
  );
}

export const VisitNotesSection: React.FC<VisitNotesSectionProps> = ({
  expanded,
  onExpandedChange,
  notes,
  onNotesChange,
  notesPinned,
  onNotesPinnedChange,
}) => {
  const handleNotesChange = (value: string) => {
    onNotesChange(value);
    if (value.trim() === '') {
      onNotesPinnedChange(false);
    }
  };

  return (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <button
        type="button"
        onClick={() => onExpandedChange(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors"
      >
        <span className="font-bold text-gray-900">Notes</span>
        {expanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </button>
      {expanded && (
        <div className="p-4 space-y-3">
          <textarea
            value={notes}
            onChange={(e) => handleNotesChange(e.target.value)}
            rows={4}
            placeholder="Additional notes..."
            className="w-full px-4 py-3 border border-gray-300 rounded-lg outline-none resize-none focus:ring-2 focus:ring-brand-500"
          />
          <PinCheckbox
            checked={notesPinned}
            disabled={notes.trim() === ''}
            onChange={onNotesPinnedChange}
          />
        </div>
      )}
    </div>
  );
};
